const MAX_SIZE_MB = 10
const MAX_SIZE_BYTES = MAX_SIZE_MB * 1024 * 1024

export function fileUploadHint() {
	document.querySelectorAll('.widget--file .widget__input-container').forEach((container) => {
		const input = container.querySelector('input[type="file"]')
		if (!input) return

		const types = input.accept
			? input.accept
					.split(',')
					.map((t) => t.trim().replace(/^\./, '').replace(/\/.+$/, '').toUpperCase())
					.filter(Boolean)
					.join(', ')
			: null

		const hint = document.createElement('span')
		hint.className = 'widget__accept-hint'
		hint.textContent = [types, `max. ${MAX_SIZE_MB} MB`].filter(Boolean).join(' • ')
		container.append(hint)

		const error = document.createElement('p')
		error.className = 'widget__size-error'
		error.hidden = true
		error.textContent = `Die Datei darf maximal ${MAX_SIZE_MB} MB groß sein.`
		container.after(error)

		input.addEventListener('change', () => {
			const file = input.files?.[0]
			const tooLarge = file && file.size > MAX_SIZE_BYTES

			error.hidden = !tooLarge

			if (tooLarge) {
				input.value = ''
			}
		})
	})
}
